import { Card, Table, Typography } from 'antd';
import type { FC } from 'react';

import { getResources } from './helpers';
import styles from './styles.module.less';
import { getColumns } from './tableConfig';

const Fonetica: FC = () => (
  <div className={styles.wrapper} data-testid="Fonetica">
    <div className={styles.headline}>
      <Typography.Title level={3}>Welcome to the Despegando hacia la lectura: FONÉTICA!</Typography.Title>
      <div>
        Essential instructional components organized by Stage and Module provide everything you will need to place in students’
        hands for reading, writing, and assessment.
      </div>
    </div>

    <Card>
      <Table
        columns={getColumns()}
        dataSource={getResources()}
        pagination={false}
        rowKey="isbn"
        scroll={{ x: 700 }}
        size="small"
        tableLayout="auto"
      />
    </Card>
  </div>
);

export default Fonetica;
